// src/contexts/PaywallContext.jsx
//
// Gancho ÚNICO de disparo do paywall (extension point). Neste prompt é apenas um
// PLACEHOLDER: guarda o `contexto` (state) e delega a abertura ao `onOpen` do host
// (em PlataformaPessoal, onOpen = setActiveTab("premium")).
//
// A assinatura `abrirPaywall(contexto)` é ESTÁVEL — o Prompt 4 troca só a
// implementação (modal/slides contextual + checkout por plataforma) sem mexer nos
// call-sites (GatePremium / ItemAvaliation).

// 30/09/2026: no app NATIVO o `onOpen` da PlataformaPessoal abre o funil novo
// do Premium (Comparativo → Lembrete → Planos). Fora do provider, onde antes
// o gancho virava no-op calado, o nativo abre o mesmo funil (a web segue
// no-op). Ver features/premium/abrirPremium.

import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { abrirPremiumPorBotao } from "../features/premium/abrirPremium";

const PaywallContext = createContext(null);

const FORA_DO_PROVIDER = {
  abrirPaywall: (contexto) => {
    abrirPremiumPorBotao(contexto, "paywall");
  },
  contextoPaywall: null,
};

export const PaywallProvider = ({ onOpen, children }) => {
  const [contextoPaywall, setContextoPaywall] = useState(null);

  const abrirPaywall = useCallback(
    (contexto) => {
      const ctx = contexto || null;
      setContextoPaywall(ctx); // guardado p/ o Prompt 4 ler o contexto contextual
      if (typeof onOpen === "function") onOpen(ctx);
    },
    [onOpen]
  );

  const value = useMemo(
    () => ({ abrirPaywall, contextoPaywall }),
    [abrirPaywall, contextoPaywall]
  );

  return <PaywallContext.Provider value={value}>{children}</PaywallContext.Provider>;
};

export const usePaywall = () => {
  const ctx = useContext(PaywallContext);
  if (!ctx) {
    // Fail-safe: fora do provider nunca quebra o render. No nativo abre o
    // funil; na web vira no-op, como sempre foi.
    return FORA_DO_PROVIDER;
  }
  return ctx;
};

export default PaywallContext;
